import { parseBooleanValue } from "../../util";
import { IAttachment } from "../model/Attachment";

const AttachmentParamMapper = (item: IAttachment) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid),
    anonymised: parseBooleanValue(item.anonymised),

    originalAttachmentId: item.originalAttachmentId
  };
};

export default AttachmentParamMapper;
